// Simple persistent state hook for React using sessionStorage or localStorage
// Usage:
// const [value, setValue] = usePersistentState('my.key', 'default', 'session');
// storageType: 'session' | 'local' (default 'session')

import { useEffect, useState, useRef } from 'react';

const getStorage = (type) => (type === 'local' ? window.localStorage : window.sessionStorage);

export default function usePersistentState(key, initialValue, storageType = 'session') {
  const storageRef = useRef(storageType);
  const [state, setState] = useState(() => {
    try {
      const storage = getStorage(storageRef.current);
      const stored = storage.getItem(key);
      return stored !== null ? JSON.parse(stored) : initialValue;
    } catch (e) {
      // Fallback on SSR or parsing error
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      const storage = getStorage(storageRef.current);
      storage.setItem(key, JSON.stringify(state));
    } catch (_) {
      // ignore write errors
    }
  }, [key, state]);

  return [state, setState];
}
